export const getHoveredId = (node) => `${node.id}${node.name}`
